const utils = {
  toRad(val) {
    let returnVal = val * Math.PI;
    returnVal /= 180;
    return returnVal;
  },
  toDeg(val) {
    let returnVal = 180 / Math.PI;
    returnVal *= val;
    return returnVal;
  },
  midPoint(latStart, lonStart, latEnd, lonEnd) {
    const dLng = utils.toRad(lonEnd - lonStart);
    const lat1 = utils.toRad(latStart);
    const lat2 = utils.toRad(latEnd);
    const lon1 = utils.toRad(lonStart);
    const bX = Math.cos(lat2) * Math.cos(dLng);
    const bY = Math.cos(lat2) * Math.sin(dLng);
    const lat3 = Math.atan2(Math.sin(lat1) + Math.sin(lat2), Math.sqrt((Math.cos(lat1) + bX) * (Math.cos(lat1) + bX) + bY * bY)); // eslint-disable-line
    const lon3 = lon1 + Math.atan2(bY, Math.cos(lat1) + bX);

    return {
      lat: utils.toDeg(lat3),
      lon: utils.toDeg(lon3),
    };
  },
  map(x, inMin, inMax, outMin, outMax) {
    return (x - inMin) * (outMax - outMin) / (inMax - inMin) + outMin; // eslint-disable-line
  },
};

export default utils;



// WEBPACK FOOTER //
// ./src/services/GlobeUtils.js